export default "__VITE_ASSET__8434ef17__"